import { useState } from 'react';
import { api } from '../lib/api';

/** Hook para el viewer inline del cheque (toggle por id). */
export function useCheckPreview() {
  const [preview, setPreview] = useState<{ id: string; url: string } | null>(null);
  async function toggle(id: string) {
    if (preview?.id === id) { setPreview(null); return; }
    try {
      const r = await api.get<{ url: string }>(`/api/checks/${id}/file-url`);
      setPreview({ id, url: r.url });
    } catch { /* no file */ }
  }
  return { preview, toggle };
}

/** Fila de tabla con el viewer embebido del cheque (PDF o imagen). */
export function CheckPreviewRow({ url, colSpan }: { url: string; colSpan: number }) {
  return (
    <tr>
      <td colSpan={colSpan} style={{ padding: 8, background: 'var(--bg, #f3f4f6)' }}>
        <iframe
          title="check-preview"
          src={url}
          style={{ width: '100%', height: 380, border: '1px solid var(--border)', borderRadius: 8, background: 'var(--card)' }}
        />
      </td>
    </tr>
  );
}
